import lazyLoading from "./lazyLoading";

export default {
  name: "lab",
  meta: {
    icon: "fa-flask",
    expanded: false,
    label: "Lab",
    permissions: [
      "view own commercial dashboard",
      "view all commercial dashboards",
      "manage commercial focus"
    ]
  },

  children: [
    {
      name: "commercial-dashboard",
      path: "/admin/commercial-dashboard",
      meta: {
        title: "Dashboard commercial",
        label: "Dashboard commercial",
        permissions: [
          "view own commercial dashboard",
          "view all commercial dashboards"
        ]
      },
      component: lazyLoading("commercial-dashboard", true)
    },
    {
      name: "commercial-focus-settings",
      path: "/admin/settings/commercial-focus",
      meta: {
        title: "Focus commercial",
        label: "Focus commercial",
        permissions: "manage commercial focus"
      },
      component: lazyLoading("settings/commercial-focus", true)
    },
    {
      name: "lead-scoring-workspace",
      path: "/admin/lab/lead-scoring/workspace",
      meta: {
        title: "Lead Scoring",
        label: "Lead Scoring",
        superadminOnly: true
      },
      component: lazyLoading("lab/LeadScoringWorkspace", true)
    },
    {
      name: "diderot-shop",
      path: "/preview/prototypes",
      meta: {
        title: "Diderot Shop",
        label: "Diderot Shop",
        external: true
      }
    },
    {
      name: "mobile-app",
      path: "/preview/prototypes/mobile-app/demo.html",
      meta: {
        title: "Mobile App",
        label: "Mobile App",
        external: true
      }
    }
  ]
};
